module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [(_vm.$route.name === 'users') ? _c('span', [_vm._v("\n              Users\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'users' && _vm.$route.name.indexOf('user') !== -1) ? _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_vm._v("Users")]), _vm._v(" "), _c('span', [_vm._v("→")]), _vm._v(" "), (_vm.$route.name === 'user') ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.currentUser ? _vm.currentUser.first_name : '') + "\n                  " + _vm._s(_vm.currentUser ? _vm.currentUser.last_name : '') + "\n              ")]) : _c('span', [_vm._v("New User")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "is-pulled-right"
  }, [_c('router-link', {
    staticClass: "button is-primary",
    attrs: {
      "to": {
        name: 'user-create'
      }
    }
  }, [_vm._v("\n              Create User\n            ")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9ce3a16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/Users.vue
// module id = 587
// module chunks = 0